import type { EditorApi } from "@circle-react-uikit/TipTapBlockEditor/types";
import type { RefObject } from "react";
import { useEffect } from "react";
import { useFormContext, useFormState } from "react-hook-form";

import type { TiptapFormValues } from "@/react/components/CommentsCompass/types";

interface UseComposerResetParams {
  collapse: () => void;
  editorApiRef: RefObject<EditorApi | null>;
  shouldRefocus: boolean;
}

export const useComposerReset = ({
  editorApiRef,
  collapse,
  shouldRefocus,
}: UseComposerResetParams) => {
  const { reset } = useFormContext<TiptapFormValues>();
  const { isSubmitSuccessful } = useFormState();

  useEffect(() => {
    if (!isSubmitSuccessful) return;
    reset({ tiptap_body: undefined });
    editorApiRef.current?.reset();
    if (shouldRefocus) editorApiRef.current?.focus();
    else editorApiRef.current?.blur();
    collapse();
  }, [isSubmitSuccessful, reset, collapse, shouldRefocus, editorApiRef]);
};
